module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "Ch-Title-2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('a', {
    attrs: {
      "href": "#/07frw"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('a', {
    attrs: {
      "href": "#/08int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 1:")]), _vm._v("    Biases—The Ultimate Threat to Higher Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 2:")]), _vm._v("    Having the Right Mindset to Lead Effectively")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Part"
  }, [_c('span', {
    attrs: {
      "href": "#/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART I: CLARITY")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 3:")]), _vm._v("    The Importance of Clarity")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 4:")]), _vm._v("    Clarity Bias #1—The Curse of Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 5:")]), _vm._v("    Clarity Bias #2—The Framing Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recap on Clarity")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Part"
  }, [_c('span', {
    attrs: {
      "href": "#/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: AUTONOMY")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 6:")]), _vm._v("    The Importance of Autonomy")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 7:")]), _vm._v("    Autonomy Bias #1—The IKEA Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 8:")]), _vm._v("    Autonomy Bias #2—Once Bitten, Twice Shy")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recap on Autonomy")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Part"
  }, [_c('span', {
    attrs: {
      "href": "#/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: RELATIONSHIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 9:")]), _vm._v("    The Importance of Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 10:")]), _vm._v("   Relationship Bias #1—Illicit Transference")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 11:")]), _vm._v("   Relationship Bias #2—Similar to Me")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recap on Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Part"
  }, [_c('span', {
    attrs: {
      "href": "#/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: EQUITY")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 12:")]), _vm._v("   The Importance of Equity")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 13:")]), _vm._v("   Equity Bias #1—Default Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 14:")]), _vm._v("   Equity Bias #2—Extension Neglect")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recap on Equity")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter ParaOverride-3"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Semibold _idGenCharOverride-4"
  }, [_vm._v("Chapter 15:")]), _vm._v("   Putting It All Together")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1 ParaOverride-3"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: CARE Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5634ce87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06-toc.vue
// module id = 75
// module chunks = 0